import { POIFilterType } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiFilterType';

import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';

export function getDimensionHiddenSheetArticles(
    state: Pick<PlacementState, 'dimensionSettings' | 'poiSelection' | 'pois' | 'workingPlane'>
): Record<string, string[]> | undefined {
    const index = state.poiSelection.current.index;
    if (
        !state.dimensionSettings.visible ||
        state.dimensionSettings.displayMode !== 'overlay' ||
        !state.workingPlane ||
        index === undefined
    ) {
        return undefined;
    }

    const poi = state.pois[index];
    return poi?.filterType === POIFilterType.Wall ? poi.articles : undefined;
}
